import { render } from "./azureFile.vue?vue&type=template&id=dcb430b8"
import script from "./azureFile.vue?vue&type=script&lang=js"
export * from "./azureFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__